import { makeAutoObservable } from "mobx";
import { ILoginRequest, IUser, IUserResponce, RoleNames } from "@drone-parts.garphild.pro/interfaces";
import RestApiQuery, { ApiEndpoints } from "../helpers/rest-api-query";
import { notification } from "antd";

class UserStorage implements Omit<IUser, 'password'> {
  businessName: string;
  email: string;
  roles: RoleNames[];
  _id: string;

  needLogIn: string;

  constructor() {
    this.needLogIn = localStorage.getItem('needLogIn') || '';
    makeAutoObservable(this);
  }

  get isAuthorized() {
    return !this.needLogIn;
  }

  setNeedLogIn() {
    this.needLogIn = 'true';
    localStorage.setItem('needLogIn', 'true');
  }

  async login(email: string, password: string) {
    try {
     const response = await RestApiQuery
      .post<ILoginRequest, IUserResponce>(ApiEndpoints.Login, { email, password })
      if (!response) {
        throw new Error('Login failed');
      }
      this._id = response.user._id;
      this.businessName = response.user.businessName;
      this.email = response.user.email;

      localStorage.removeItem('needLogIn')
      window.location.reload();
    } catch (error) {
      notification.error({ message: "Failed to login" });
    }
  }
}

const userStorage = new UserStorage();

export default userStorage;
